import React from 'react';
import { ToastContainer } from 'react-toastify';

function AppToaster() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnVisibilityChange
      draggable
      pauseOnHover
      bodyClassName="toast_body"
    />
  );
}

export default AppToaster;
